
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { AxiosResponse } from "axios"
import { CategoriesApi } from "../../http/api/categories.api"
import { TemplateSheetGetReq, TemplateSheetGetRes, TemplateSheetReq, TemplateSheetRes, TemplateSheetDelRes, TemplateSheetDelReq, TemplateDefaultReq, TemplateDefaultRes } from "../../types/api/categories.api.types"
import { HasNextPart, HasPart } from "../../types/common.types"
import { handleTokenRefreshedRequest } from "../../utils/handleThunkAuth"
import { TemplatesApi } from "../../http/api/template.api"
import { stat } from "fs"

type TemplateSliceState = {
    templates: any[],
    defaultTemplates: any[],
} & HasNextPart & HasPart

const initialState: TemplateSliceState = {
    templates: [],
    defaultTemplates: [],
    can_next: false,
    part: 0
}
        

    export const createNewTemplate = createAsyncThunk(
        'lk/template-create',
        async (req: TemplateSheetReq, { dispatch }) => {
            const res: AxiosResponse<TemplateSheetRes> = await handleTokenRefreshedRequest(null, TemplatesApi.CreateNewAnalysisTemplate, req)
            return res.data
        })

    export const getAllTemplates = createAsyncThunk(
        'lk/template/get',
        async (req: TemplateSheetGetReq, { dispatch }) => {
            const res: AxiosResponse<TemplateSheetGetRes> = await handleTokenRefreshedRequest(null, TemplatesApi.GetAnalysisTemplate, req)
            return res.data
        })

    export const DelTemplate = createAsyncThunk(
    'lk/template-delete',
    async (req: TemplateSheetDelReq, { dispatch }) => {
        const res: AxiosResponse<TemplateSheetDelRes> = await handleTokenRefreshedRequest(null, TemplatesApi.DelAnalysisTemplate, req)
        return res.data
    })

            

export const TemplateSlice = createSlice({
    name: "templates",
    initialState,
    reducers: {
        resetTemplates: state => {
            state.templates = initialState.templates
            state.can_next = false
            state.part = 0
        },
        incrementTemplatesProductsPart: state => {
            state.part += 1
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getAllTemplates.fulfilled, (state, action) => {
          state.templates = action.payload.templates
        })
    },
})
export const {
    resetTemplates,
    incrementTemplatesProductsPart,
} = TemplateSlice.actions

export const templatesReducer = TemplateSlice.reducer